import type { SerializedAuthenticatedUser } from '@dmp/qqms/data-access';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type UserState = SerializedAuthenticatedUser;

interface UserStore {
    currentUser: SerializedAuthenticatedUser | undefined;
    users: Record<string, UserState>;
}

const defaultState: UserStore = {
    currentUser: undefined,
    users: {},
};

export const useUserStore = create(
    devtools(() => defaultState, { name: 'QQMS.User', store: 'QQMS.User' })
);

export const resetUserStore = () => useUserStore.setState(defaultState, true);

export const getCurrentUser = (state: UserStore): UserState | undefined =>
    state.currentUser;

export const setCurrentUser = (currentUser: SerializedAuthenticatedUser) => {
    useUserStore.setState(
        (s) => ({
            ...s,
            currentUser,
        }),
        true
    );
};
